<template>
  <div class="cate-hots">
    <h3>热门类目管理</h3>
    <el-form
      :inline="true"
      class="demo-form-inline"
      v-loading="loading"
      size="mini"
    >
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="toggleDialog('add')" size="mini"
            >新增</el-button
          >
        </el-button-group>
      </el-form-item>
    </el-form>
    <el-alert
      title="需确保有8个可展示的类目"
      type="warning"
      effect="dark"
      :closable="false"
    >
    </el-alert>
    <el-table :data="hotCates" style="width: 100%">
      <el-table-column prop="id" label="序号"> </el-table-column>
      <el-table-column prop="name" label="工作类别"> </el-table-column>
      <el-table-column prop="ifshow" label="是否展示"> </el-table-column>
      <el-table-column prop="priority" label="排序" sortable> </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">修改</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :title="`${form.id ? '修改' : '新增'}热门类目`"
      :visible.sync="dialog.add"
      :before-close="resetDialogForm"
    >
      <el-form
        ref="hotCate"
        :model="form"
        :rules="roles"
        label-width="80px"
        size="mini"
      >
        <el-form-item label="展示名称" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="职位类型" prop="firstCategory">
          <el-select
            v-model="form.firstCategory"
            value-key="id"
            placeholder="请选择"
            @change="cateChange('firstCategory')"
          >
            <el-option
              v-for="item in firstCates"
              :key="item.id"
              :label="item.name"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属职业" prop="secondCategory">
          <el-select
            v-model="form.secondCategory"
            value-key="id"
            :multiple="true"
            :multiple-limit="1"
            placeholder="请选择"
            @change="cateChange('secondCategory')"
          >
            <el-option
              v-for="item in secondCates"
              :key="item.id"
              :label="item.name"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="技能标签" prop="thirdCategory">
          <el-select
            v-model="form.thirdCategory"
            value-key="id"
            :multiple="true"
            :multiple-limit="3"
            placeholder="请选择"
          >
            <el-option-group
              v-for="group in form.secondCategory"
              :key="group.id"
              :label="`${group.name}：`"
            >
              <el-option
                v-for="item in getCatesById(group.id)"
                :key="item.id"
                :label="item.name"
                :value="item"
              >
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="是否展示" prop="ifshow">
          <el-select v-model="form.ifshow">
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序" prop="priority">
          <el-input v-model="form.priority"></el-input>
        </el-form-item>
        <el-form-item label="类目图片" prop="image">
          <el-upload
            action="https://up-z1.qbox.me/"
            :show-file-list="false"
            :on-success="handleSuccess"
            :before-upload="beforeUpload"
            :data="uploadData"
          >
            <img v-if="form.image" :src="form.image" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <el-input type="hidden" v-model="form.image"></el-input>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetDialogForm">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import api from "../api";
const { workCateList } = api;
export default {
  name: "hotCate",
  data() {
    return {
      loading: true,
      cates: [],
      hotCates: [],
      dialog: {
        add: false,
      },
      form: {
        name: "",
        firstCategory: "",
        secondCategory: [],
        thirdCategory: [],
        ifshow: 1,
        priority: 0,
        image: "",
      },
      roles: {
        name: [
          {
            required: true,
            message: "请输入展示名称",
            trigger: "blur",
          },
        ],
        firstCategory: [
          {
            required: true,
            message: "请选择职位类型",
            trigger: "change",
          },
        ],
        secondCategory: [
          {
            required: true,
            message: "请选择职位类型",
            trigger: "change",
          },
        ],
        image: [
          {
            required: true,
            message: "请上传类目图片",
            trigger: "blur",
          },
        ],
      },
      uploadData: {
        token: "",
        name: "",
        chunk: 0,
        chunks: 1,
      },
    };
  },
  computed: {
    firstCates() {
      return this.getCatesById(0);
    },
    secondCates() {
      return this.getCatesById(this.form.firstCategory.id);
    },
  },
  watch: {},
  mounted() {
    this.fetch();
    this.getAllTags();
    this.getToken();
  },
  methods: {
    async getToken() {
      let res = await api.upload.token();
      if (res.data.code == 200) {
        this.uploadData.token = res.data.data.up_token;
      }
    },
    toggleDialog(name) {
      this.dialog[name] = !this.dialog[name];
    },
    async getAllTags() {
      let {
        data: { code, data },
      } = await api.workCateList.getAllTags();
      if (code === 200) {
        this.cates = data.workCategory;
      }
    },
    getCatesById(id) {
      let arr = [];
      this.cates.forEach((item) => {
        if (item.parentId === id) {
          arr.push(item);
        }
      });
      return arr;
    },
    async fetch() {
      this.loading = true;
      let {
        data: { code, data },
      } = await workCateList.getHotCates();
      if (code == 200) {
        this.hotCates = data;
      }
      this.loading = false;
    },
    async save() {
      let action = this.form.id ? "updateHotCates" : "addHotCates";
      let {
        data: { code },
      } = await workCateList[action](this.form);
      if (code === 200) {
        this.$message.success("工作类别保存成功");
        this.resetDialogForm();
      }
      this.fetch();
    },
    submit() {
      this.$refs["hotCate"].validate((valid) => {
        console.log(valid);
        if (valid) {
          this.save();
        }
      });
    },
    resetDialogForm() {
      this.form = {
        name: "",
        firstCategory: {
          name: "",
          id: "",
        },
        secondCategory: [],
        thirdCategory: [],
        ifshow: 1,
        priority: 0,
        image: "",
      };
      this.toggleDialog("add");
    },
    cateChange(name) {
      switch (name) {
        case "firstCategory":
          this.form.secondCategory = [];
          this.form.thirdCategory = [];
          break;
        case "secondCategory":
          this.delThirdCates();
          break;
        default:
      }
    },
    inArr(id, array) {
      let isIn = false;
      array.forEach((item) => {
        if (item.id === id) {
          isIn = true;
        }
      });
      return isIn;
    },
    delThirdCates() {
      let thirdCates = this.form.thirdCategory;
      let newArr = [];
      thirdCates.forEach((item) => {
        if (this.inArr(item.parentId, this.form.secondCategory)) {
          newArr.push(item);
        }
      });
      this.form.thirdCategory = newArr;
    },
    async handleEdit(row) {
      this.toggleDialog("add");
      this.form = row;
    },
    handleSuccess(res, file) {
      this.form.image = `https:\/\/image.duiyou360.com/${res.key}`;
    },
    beforeUpload(file) {
      let sizeM = file.size / 1024 / 1024;
      this.chunks = Math.ceil(sizeM / 10); // 大于10m文件进行分片
      this.uploadData.name = file.name;
    },
  },
};
</script>
<style>
.el-upload {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.el-upload img {
  width: 100%;
  height: 100%;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/views/cate/hots.vue